export default "__VITE_ASSET__CGgXaQP8__"